import { render, staticRenderFns } from "./MultiMetricCard.vue?vue&type=template&id=dcd23a1e&scoped=true&"
import script from "./MultiMetricCard.vue?vue&type=script&lang=js&"
export * from "./MultiMetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MultiMetricCard.vue?vue&type=style&index=0&id=dcd23a1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd23a1e",
  null
  
)

export default component.exports